import {TextAlignment} from 'pdf-lib';

import {Alignments, FieldSpecialType, IFieldSettings, StampSignatureType} from '@core/api/data-access';
import {DateFormatType} from '@global-data';
import {BE} from '@utils';

import BEProp = BE.BEProp;
import BESchema = BE.BESchema;

@BESchema()
export class FieldSettingsModel implements IFieldSettings {
	@BEProp() SpecialType: FieldSpecialType = FieldSpecialType.None;
	@BEProp() Alignment: Alignments | TextAlignment = document.dir === 'rtl' ? Alignments.Right : Alignments.Left;
	@BEProp() FontSize = 0; //	0 - auto font size
	@BEProp() Multiline = false;
	@BEProp() CalcPageFromEnd = false;
	@BEProp() AttachmentFileCount = 0;
	@BEProp() AttachmentFileCountMin = 0;
	@BEProp() AllowStampSignature: StampSignatureType = StampSignatureType.NotAllowed;
	@BEProp() StampSignatureImage = '';
	@BEProp() Group = '';
	@BEProp() Metatag = '';
	@BEProp() DateFormat: string = DateFormatType.DDMMYYYY;
	@BEProp({
		transform: (value: any) => {
			return isFinite(value) ? Number(value) : 0;
		},
	})
	Ordinal = 0;

	/* --------------- Validation Rule --------------- */
	@BEProp() ValidationRule = '';

	/* -------------------------------------------------------------------------------------------------------------- */
	constructor(init: Partial<FieldSettingsModel> | string) {
		if (typeof init === 'string') {
			Object.assign(this, JSON.tryParse(init, {}));
		} else {
			Object.assign(this, init);
		}

		if (!this.Ordinal) this.Ordinal = 0;
	}

	public toJSON(): IFieldSettings {
		return {
			SpecialType: this.SpecialType,
			Alignment: this.Alignment,
			FontSize: this.FontSize,
			Multiline: this.Multiline,
			CalcPageFromEnd: this.CalcPageFromEnd,
			AttachmentFileCount: this.AttachmentFileCount,
			AttachmentFileCountMin: this.AttachmentFileCountMin,
			AllowStampSignature: this.AllowStampSignature,
			StampSignatureImage: this.StampSignatureImage,
			Group: this.Group,
			Metatag: this.Metatag,
			DateFormat: this.DateFormat,
			ValidationRule: this.ValidationRule,
			Ordinal: isFinite(this.Ordinal) ? Number(this.Ordinal) : 0,
		};
	}

	toString(): string {
		return JSON.stringify(this);
	}
}
